<template>
    <div>
        <div style="width: 100%;overflow-x: hidden;">
            <div class="banner">
                <div class="textbox">
                    <div class="banner-text1">
                        <span v-show="showNewsDetail" @click="goBack" style="cursor: pointer;">
                            <&nbsp;返回< /span>&nbsp;&nbsp;
                                <span>首页</span>&nbsp;>&nbsp;<span>新闻动态</span>&nbsp;>&nbsp;<span>详情</span>
                            </span>
                    </div>

                    <div class="banner-text2">关注移动数字证书（CA）互认最新动态，了解最新政策</div>

                </div>
            </div>
            <div class="news-content">
                <div class="left">
                    <!-- <div class="navbox">
                        <div v-for="(item, index) in tabsList" :key="index" class="nav"
                            :class="{ active: item.isActive }" @click="toggleActive(item)"
                            @mouseover="item.isHovered = true" @mouseout="item.isHovered = false">
                            <div class="navText">
                                <span>{{ item.name }}</span>
                                <div class="indicator" v-show="item.isActive"></div>
                            </div>
                        </div>


                    </div> -->
                    <div class="title">政策资讯</div>
                    <div class="line1"></div>

                    <div v-show="!showNewsDetail">
                        <div class="news-box" v-for="(item, index) in newsList" :key="index">
                            <div class="news-title" @click="toNewsDetail(item.newsUrl)">{{ item.newsTitle }}</div>
                            <div class="news-time">{{ item.publishTime }}</div>
                        </div>


                    </div>





                </div>
                <div class="right">
                    <div class="title">最新动态</div>
                    <div class="content">
                        <div class="news-item" v-for="item in newsList2" @click="toNewsDetail(item.newsUrl)">
                            {{ item.newsTitle }}
                        </div>

                    </div>
                </div>

            </div>


            <div class="pagination" v-show="!showNewsDetail">
                <el-pagination v-model:current-page="newParms.current" v-model:page-size="newParms.size"
                    :page-sizes="[50, 100, 150, 200]" layout="prev, pager, next,sizes," :total="newParms.total"
                    background @size-change="handleSizeChange" @current-change="handleCurrentChange" />
            </div>


            <div class="bigbottom">
                <div class="bottom" @click="tous">

                </div>
            </div>



        </div>
    </div>
</template>

<script lang='ts' setup>
import { reactive, toRefs, ref, onMounted } from 'vue'

import { getNews } from '../utils/axios/index.js'

import { useRoute } from 'vue-router'
const route = useRoute()
import { useRouter } from "vue-router";
const router = useRouter();
const tous = () => {
    router.push('/contactUs')
}

onMounted(() => {

    getNews(newParms.value).then(res => {
        newsList.value = res.data.records
        newParms.value.total = res.data.total
        newsList2.value = res.data.records.slice(0, 6)
    }).catch(err => {
        console.log(err);
    })

})

const handleSizeChange = (val) => {
    newParms.value.size = val
    getNews(newParms.value).then(res => {
        newsList.value = res.data.records
        newParms.value.total = res.data.total
    }).catch(err => {
        console.log(err);
    })
}

const handleCurrentChange = (val) => {
    newParms.value.current = val
    getNews(newParms.value).then(res => {
        newsList.value = res.data.records
        newParms.value.total = res.data.total
    }).catch(err => {
        console.log(err);
    })
}

let newsList = ref([])
let newsList2 = ref([])

let newParms = ref({
    current: 1,
    size: 50,
    total: 0,
})

let tabsList = ref([
    { name: 'CA互认政策新闻', isHovered: false, isActive: true, value: 1, },
    { name: '中招动态', isHovered: false, isActive: false, value: 2, },

])
let activeName = ref('1')
const toggleActive = (item: any) => {
    tabsList.value.map((item: any) => {
        item.isActive = false;
    })

    item.isActive = true;
    activeName.value = item.value
}
let showNewsDetail = ref(false)
const toNewsDetail = (url) => {
    // showNewsDetail.value = true
    window.open(url, '_blank');
}

const goBack = () => {
    showNewsDetail.value = false
}




let currentPage = ref(1)
let pageSize = ref(100)

</script>
<style lang="scss" scoped>
.banner {
    width: 100%;
    height: 300px;
    position: relative;
    background: url('../assets/img/asked/banner-bg.png') no-repeat center center;
    background-size: cover;
    margin-top: 88px;
    padding: 1px;

    .textbox {
        width: 1200px;
        height: 120px;
        position: absolute;
        top: 100px;
        left: 50%;
        transform: translate(-50%);
    }

    .banner-text1 {
        color: #525760;
        
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 21px;
    }

    .banner-text2 {
        color: #23252B;
        
        font-size: 36px;
        font-style: normal;
        font-weight: 600;
        line-height: 54px;
        margin-top: 30px;
    }
}

.news-content {
    width: 1200px;
    height: 100%;
    display: flex;
    margin: 0 auto;

    .left {
        width: 74%;
        height: 100%;

        .title {
            color: #23252B;
            
            font-size: 16px;
            font-style: normal;
            font-weight: 500;
            line-height: 56px;
            // width: 90%;
            margin: 0 auto;
        }

        .news-box {
            display: flex;
            width: 95%;
            justify-content: space-between;
            align-items: center;
            padding: 12px 0;
            // margin-left: 50px;

            .news-title {
                width: 70%;
                color: #23252B;
                
                font-size: 18px;
                font-style: normal;
                font-weight: 600;
                line-height: 27px;
                cursor: pointer;
            }

            .news-time {
                color: var(--Color-Neutral-neutral-9, #969AA0);
                
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: 21px;

            }
        }
    }

    .right {
        width: 25%;
        height: 100%;
        margin-top: 50px;

        .title {
            color: #000;
            
            font-size: 18px;
            font-style: normal;
            font-weight: 600;
            line-height: 27px;
            /* 150% */
        }

        .content {
            width: 100%;
            height: 300px;
            border-radius: var(--Radius-Border-radius-4, 8px);
            background: #F7F8FA;
            margin-top: 15px;
            display: flex;
            padding: 32px 32px 44px 32px;
            flex-direction: column;
            align-items: flex-start;
            align-self: stretch;


            .news-item {
                width: 100%;
                color: #000;
                
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                line-height: 30px;
                cursor: pointer;
            }


        }
    }

}

.bigbottom {
    width: 1200px;
    margin: 0 auto;
    margin-bottom: 60px;
}


.bottom {
    width: 1000px;
    height: 80px;
    background: url('../assets/img/news/bottom.png') no-repeat center center;
    background-size: cover;
    border-radius: var(--Radius-Border-radius-4, 8px);
    margin-top: 50px;
    cursor: pointer;

}

.pagination {
    width: 58%;
    height: 80px;
    margin-left: 10%;
    margin-top: 80px;
    display: flex;
    justify-content: center
}


.news-detail-title {
    color: #333;
    font-family: Inter;
    font-size: 38px;
    font-style: normal;
    font-weight: 400;
    line-height: 56px;
}



.navbox {
    width: 80%;
    display: flex;
    margin-top: 50px;


}

.nav {
    /* width: 100%; */
    white-space: nowrap;
    padding: 0 50px 0 50px;
    color: var(--text-color-primary, #303133);
    text-align: center;
    
    font-size: 16px;
    font-style: normal;
    font-weight: 400;

}

.navText {
    position: relative;
}

.nav:hover {
    cursor: pointer;
    /* 鼠标移入时变为小手 */
    color: #409EFF;
    /* 文字变为蓝色 */
}

.nav.active {
    color: #409EFF;
    /* 文字变为蓝色 */
}

.indicator {
    width: 100%;
    border: 1px solid #409EFF;
    position: absolute;
    bottom: -10px;
}

.nav.active .indicator {
    opacity: 1;
    /* 选中时指示器不透明度为1 */
}

.line1 {
    border-bottom: 1px solid var(--Color-Auxiliary-auxiliary-2, #D7D7DC);
    width: 98%;
    // margin: 0 auto;
    margin-top: 9px;
}


:deep(.btn-prev .el-icon) {
    font-size: 16Px !important;
    line-height: 32px;
}
:deep(.btn-next .el-icon) {
    font-size: 16Px !important;
    line-height: 32px;
}

</style>